import {
  IsString,
  IsOptional,
  IsBoolean,
  IsEnum,
  IsDateString,
  MaxLength,
  IsNotEmpty,
  IsUUID,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ProgramStatus } from '../../../enums'

export class CreateProgramVersionDto {
  @ApiProperty({ description: 'Program UUID' })
  @IsUUID()
  @IsNotEmpty()
  programId!: string

  @ApiProperty({ example: '2024', description: 'Version tag/number' })
  @IsString()
  @IsNotEmpty()
  @MaxLength(64)
  versionTag!: string

  @ApiPropertyOptional({ enum: ProgramStatus, default: 'PUBLISHED' })
  @IsEnum(ProgramStatus)
  @IsOptional()
  status?: ProgramStatus

  @ApiPropertyOptional({
    description: 'Is this the current active version?',
    default: false,
  })
  @IsBoolean()
  @IsOptional()
  isCurrent?: boolean

  @ApiPropertyOptional({ description: 'Valid from date (YYYY-MM-DD)' })
  @IsDateString()
  @IsOptional()
  validFrom?: string

  @ApiPropertyOptional({ description: 'Valid to date (YYYY-MM-DD)' })
  @IsDateString()
  @IsOptional()
  validTo?: string

  @ApiPropertyOptional({ description: 'URL to official reference document' })
  @IsString()
  @IsOptional()
  @MaxLength(512)
  officialRefUrl?: string

  @ApiPropertyOptional({ description: 'Official reference code' })
  @IsString()
  @IsOptional()
  @MaxLength(128)
  officialRefCode?: string

  @ApiPropertyOptional({ description: 'Asset ID for attached document' })
  @IsString()
  @IsOptional()
  @MaxLength(255)
  documentAssetId?: string

  @ApiPropertyOptional({ description: 'URI to document' })
  @IsString()
  @IsOptional()
  @MaxLength(512)
  documentUri?: string

  @ApiPropertyOptional({ description: 'Document MIME type' })
  @IsString()
  @IsOptional()
  @MaxLength(64)
  documentMime?: string

  @ApiPropertyOptional({ description: 'Document title' })
  @IsString()
  @IsOptional()
  @MaxLength(255)
  documentTitle?: string

  @ApiPropertyOptional({ description: 'Internal notes' })
  @IsString()
  @IsOptional()
  notes?: string
}
